var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5184 13.1479C11.9707 13.1479 13.148 11.9706 13.148 10.5183C13.148 9.06598 11.9707 7.88867 10.5184 7.88867C9.06611 7.88867 7.88879 9.06598 7.88879 10.5183C7.88879 11.9706 9.06611 13.1479 10.5184 13.1479Z",
    stroke: "white",
    strokeWidth: 1.3148,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75307 11.29V9.74728C1.75307 8.83568 2.49812 8.08186 3.41848 8.08186C5.005 8.08186 5.65364 6.9599 4.85599 5.58375C4.4002 4.79487 4.67192 3.76932 5.46957 3.31352L6.98597 2.44576C7.67843 2.03379 8.57249 2.27922 8.98447 2.97168L9.08088 3.13822C9.86976 4.51437 11.167 4.51437 11.9647 3.13822L12.0611 2.97168C12.4731 2.27922 13.3671 2.03379 14.0596 2.44576L15.576 3.31352C16.3736 3.76932 16.6454 4.79487 16.1896 5.58375C15.3919 6.9599 16.0406 8.08186 17.6271 8.08186C18.5387 8.08186 19.2925 8.82692 19.2925 9.74728V11.29C19.2925 12.2016 18.5474 12.9554 17.6271 12.9554C16.0406 12.9554 15.3919 14.0773 16.1896 15.4535C16.6454 16.2512 16.3736 17.2679 15.576 17.7237L14.0596 18.5915C13.3671 19.0035 12.4731 18.758 12.0611 18.0656L11.9647 17.899C11.1758 16.5229 9.87853 16.5229 9.08088 17.899L8.98447 18.0656C8.57249 18.758 7.67843 19.0035 6.98597 18.5915L5.46957 17.7237C4.67192 17.2679 4.4002 16.2424 4.85599 15.4535C5.65364 14.0773 5.005 12.9554 3.41848 12.9554C2.49812 12.9554 1.75307 12.2016 1.75307 11.29Z",
    stroke: "white",
    strokeWidth: 1.3148,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.09bd1c671aa947c3877d12d3dd4b3f3b.svg";
export { ForwardRef as ReactComponent };